import { ReactNode } from 'react';
import { ErrorBoundaryProps } from '@ets/design-system';
import cx from 'classnames';

import { useSuiteApp } from '_common/suite/SuiteContext/SuiteContext';
import { IntlErrorBoundary } from '_common/components';

import styles from './Footer.module.scss';

type FooterProps = {
  id?: string;
  children: ReactNode;
  fallbackSize?: ErrorBoundaryProps['size'];
};

const Footer = ({ id, children, fallbackSize = 's' }: FooterProps) => {
  const suiteApp = useSuiteApp();

  return (
    <div id={id} className={cx(styles.footer, { [styles.editor]: suiteApp === 'document' })}>
      <IntlErrorBoundary size={fallbackSize} style={{ margin: 'auto' }}>
        <div className={styles.content}>{children}</div>
      </IntlErrorBoundary>
    </div>
  );
};

const Left = ({ children }: { children: ReactNode }) => {
  return <div className={styles.left}>{children}</div>;
};
const Right = ({ children }: { children: ReactNode }) => {
  return <div className={styles.right}>{children}</div>;
};

export default Object.assign(Footer, {
  Left,
  Right,
});
